import { render, staticRenderFns } from "./OrderSearchBar.vue?vue&type=template&id=294eb561"
import script from "./OrderSearchBar.vue?vue&type=script&lang=js"
export * from "./OrderSearchBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports